export default __webpack_public_path__ + "static/media/sergio_carrillo.8fd80647.png";